export default "__VITE_ASSET__CwMuAvBl__"